
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHeroSection from './components/AboutHeroSection';
import CompanyIntroSection from './components/CompanyIntroSection';
import CompanyHistorySection from './components/CompanyHistorySection';
import ValuesSection from './components/ValuesSection';
import AchievementsSection from './components/AchievementsSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';
import { updateSEO, addJSONLD } from '../../utils/seo';

export default function About() {
  useEffect(() => {
    // Update SEO
    updateSEO({
      title: '关于我们 - 南滇古茶公司简介',
      description: '了解南滇古茶的发展历程、企业文化和团队介绍。我们致力于打造专业的普洱茶供应链平台，传承云南茶文化，服务全球茶友。',
      keywords: '南滇古茶简介,公司介绍,企业文化,团队介绍,发展历程,云南茶文化',
      type: 'website',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`
    });

    // Add JSON-LD structured data
    addJSONLD({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "关于我们",
      "description": "南滇古茶公司简介和企业信息",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
      "mainEntity": {
        "@type": "Organization",
        "name": "南滇古茶",
        "description": "专业普洱茶供应链平台",
        "foundingDate": "2020",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "CN",
          "addressRegion": "云南省"
        }
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "关于我们",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`
          }
        ]
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHeroSection />
        <CompanyIntroSection />
        <CompanyHistorySection />
        <ValuesSection />
        <AchievementsSection />
        <TeamSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
